"use strict";

define('service/message.template',['require','exports','module','underscore','appkit/service','libs/filter.builder','uikit/uikit','view/tag.select','view/message.template.editor'],function (require, exports, module) {
  var _ = require('underscore');
  var Service = require('appkit/service');
  var FilterBuilder = require('libs/filter.builder');
  var UIKit = require('uikit/uikit');
  var TagSelectView = require('view/tag.select');
  var MessageTemplateEditor = require('view/message.template.editor');
  var MessageTemplateService = Service.extend({
    replies: {
      'build:messageTemplateEditor': 'buildMessageTemplateEditor',
      'build:messageTemplateTagModal': 'buildMessageTemplateTagModal'
    },
    initialize: function initialize() {
      this.tagFilter = new FilterBuilder().add('name');
    },
    buildMessageTemplateTagModal: function buildMessageTemplateTagModal(options) {
      options = options || {};
      var content = new TagSelectView(options),
        modal = new UIKit.Modal({
          size: 'small',
          content: content
        }),
        approveButton = new UIKit.Button({
          color: 'primary',
          text: 'Insert',
          disabled: true
        }),
        events = _.extend({}, Backbone.Events);
      content.$el.css({
        'max-height': '50vh',
        'overflow-y': 'scroll',
        'overflow-x': 'hidden'
      });
      modal.header.text = 'Insert Variable';
      modal.on('approve', function () {
        if (content.table.value) {
          events.trigger('approve', content.table.value);
        }
      }).on('modal:hidden', function () {
        modal.destroy();
        events.off().stopListening();
      }).listenTo(content, 'table:row:enter', _.debounce(function () {
        modal.trigger('approve');
        modal.visible = false;
      })).listenTo(content, 'table:row:double:press', _.debounce(function () {
        modal.trigger('approve');
        modal.visible = false;
      })).listenTo(content, 'table:change:value', function (tableView, selectedRowModel, previousRowModel) {
        var currentRowViewId = tableView.getRow(selectedRowModel).cid;
        approveButton.disabled = false;
        approveButton.$el.attr({
          'aria-controls': currentRowViewId
        });
      });
      modal.visible = true;
      modal.actions.add(new UIKit.Button({
        text: 'Cancel',
        color: 'white'
      }));
      modal.actions.addApprove(approveButton);
      return events;
    },
    buildMessageTemplateEditor: function buildMessageTemplateEditor(options) {
      options = options || {};
      options = _.extend({
        redactorOptions: _.extend({}, this.app.config.redactorDefaults, {
          macros: options.tags
        })
      }, options);
      var mte = new MessageTemplateEditor(options),
        messageTemplate = options.model,
        tagsAddressable = options.tagsAddressable,
        tags = options.tags,
        self = this;
      if (!messageTemplate || !tagsAddressable || !tags) {
        throw new Error('Required options not given');
      }
      this.configureAddressableTokenInput(mte.recipientsTokenInput, tagsAddressable);
      this.configureAddressableTokenInput(mte.ccTokenInput, tagsAddressable);
      this.configureAddressableTokenInput(mte.bccTokenInput, tagsAddressable);
      this.configureUnaddressableTokenInput(mte.subjectInput, tags);
      this.configureMessageTemplateEditorBindings(mte, messageTemplate);
      mte.on('bccButton:press', function () {
        if (mte.toggleBcc()) {
          messageTemplate.set('bcc', '');
        }
      });
      mte.on('ccButton:press', function () {
        if (mte.toggleCc()) {
          messageTemplate.set('cc', '');
        }
      });
      messageTemplate.on('sync', function () {
        this.configureMessageTemplateEditorFields(mte, messageTemplate);
      }, this);
      mte.listenTo(messageTemplate, 'change:recipients', function () {
        self.transferEmailsToInput(mte.recipientsTokenInput, messageTemplate.get('recipients'));
      });
      mte.listenTo(messageTemplate, 'change:cc', function () {
        self.transferEmailsToInput(mte.ccTokenInput, messageTemplate.get('cc'));
      });
      mte.listenTo(messageTemplate, 'change:bcc', function () {
        self.transferEmailsToInput(mte.bccTokenInput, messageTemplate.get('bcc'));
      });
      this.transferEmailsToInput(mte.recipientsTokenInput, messageTemplate.get('recipients'));
      this.transferEmailsToInput(mte.ccTokenInput, messageTemplate.get('cc'));
      this.transferEmailsToInput(mte.bccTokenInput, messageTemplate.get('bcc'));
      return mte;
    },
    configureMessageTemplateEditorFields: function configureMessageTemplateEditorFields(mte, messageTemplate) {
      var isEmail = messageTemplate.isEmail(),
        isSendable = messageTemplate.isSendable(),
        isSystem = messageTemplate.get('code.notificationKind.description') == 'System';
      if (isSystem) {
        mte.macroPluginEnabled = false;
        mte.options.redactorOptions.buttons = ["formatting", "bold", "italic", "underline", "deleted", "alignment", "link"];
      }
      if (!isSendable) {
        mte.imagePluginEnabled = false;
      }
      mte.recipientsTokenInput.freeText = isEmail;
      mte.richText = messageTemplate.isRichText();
      mte.ccButton.visible = isEmail && isSendable;
      mte.bccButton.visible = isEmail && isSendable;
      mte.subjectVisible = isEmail && isSendable;
      mte.recipientsVisible = isSendable;
      mte.ccVisible = !!messageTemplate.get('cc') && isEmail && isSendable;
      mte.bccVisible = !!messageTemplate.get('bcc') && isEmail && isSendable;
    },
    transferEmailsToInput: function transferEmailsToInput(input, emails) {
      input.collection.reset(this.request('convert:emailsToTokens', emails));
    },
    configureUnaddressableTokenInput: function configureUnaddressableTokenInput(input, tags) {
      input.resultsView.childBindings.text = 'tagName';
      input.resultsView.childBindings.description = 'description';
      input.on('search:results:text', function (text) {
        input.resultsView.collection = this.filterUnaddressableMessageTags(tags, text);
      }, this);
    },
    configureAddressableTokenInput: function configureAddressableTokenInput(input, tagsAddressable) {
      input.resultsView.childBindings.text = 'tagName';
      input.resultsView.childBindings.description = 'description';
      input.options.validateToken = _.bind(this.validateEmailToken, this);
      input.on('search:results:text', function (text) {
        input.resultsView.collection = this.filterAddressableMessageTags(tagsAddressable, text);
      }, this);
    },
    validateEmailToken: function validateEmailToken(token) {
      var text = token.get('text');
      text = text == null ? '' : String(text);
      if (token.get('textModel')) {
        return true;
      } else if (text.length > 0 && text.indexOf('@') > -1) {
        return true;
      }
      return 'Invalid Email';
    },
    filterAddressableMessageTags: function filterAddressableMessageTags(tagsAddressable, text) {
      return this.tagFilter.doFilter(tagsAddressable, text);
    },
    filterUnaddressableMessageTags: function filterUnaddressableMessageTags(tags, text) {
      return this.tagFilter.doFilter(tags, text);
    },
    configureMessageTemplateEditorBindings: function configureMessageTemplateEditorBindings(mte, messageTemplate) {
      var subjectInput = mte.subjectInput,
        form = mte.form;
      mte.model = messageTemplate;
      subjectInput.model = messageTemplate;
      subjectInput.bindings.value = 'subject';
      form.recipients.on('token:remove token:add token:revised', _.debounce(function () {
        messageTemplate.set('recipients', this.request('convert:tokensToEmails', form.recipients.collection));
      }), this);
      form.cc.on('token:remove token:add token:revised', _.debounce(function () {
        messageTemplate.set('cc', this.request('convert:tokensToEmails', form.cc.collection));
      }), this);
      form.bcc.on('token:remove token:add token:revised', _.debounce(function () {
        messageTemplate.set('bcc', this.request('convert:tokensToEmails', form.bcc.collection));
      }), this);
      mte.on('change:contentInput', function () {
        var contentInput = mte.contentInput;
        contentInput.model = messageTemplate;
        contentInput.bindings.value = 'content';
        if (!mte.richText) {
          this.configureUnaddressableTokenInput(contentInput, mte.getOption('tags'));
        }
      }, this);
    }
  });
  module.exports = MessageTemplateService;
});

